import Login from '@/pages/login/index';
import SetupAccount from '@/pages/setup-account/index';
import ResetPassword from '@/pages/reset-password/index';
import NewPassword from '@/pages/new-password/index';
import AdminPanel from '@/pages/admin-panel/index';
import UserDashboard from '@/pages/user-dashboard/index';
import DecedentInitiation from '@/pages/decedent-initiation/index';
import GeneralNotes from '@/pages/general-notes/index';

export default {
  Login,
  SetupAccount,
  ResetPassword,
  NewPassword,
  AdminPanel,
  UserDashboard,
  DecedentInitiation,
  GeneralNotes,
};
